import { useEffect } from 'react'
import { useApplicationContext } from '@/providers/ApplicationContext'
import { useModelContext } from '@/providers/ModelContext'
import { MLModelStatus } from '@/types/model'
import { useModelStepNavigation } from './useModelStepNavigation'

export const ModelDetailsPage = () => {
  const { application } = useApplicationContext()
  const { model, isFetchedAfterMount } = useModelContext()

  const { goToBaseModelScreen, goToLabelDataScreen, goToModelTrainingScreen } =
    useModelStepNavigation({
      appId: application?.id || '',
      modelId: model?.id || ''
    })

  useEffect(() => {
    if (!model || !isFetchedAfterMount) {
      return
    }

    if (model.status === MLModelStatus.Trained || model.training !== null) {
      goToModelTrainingScreen(true)
      return
    }

    if (
      model.dataset_version !== null &&
      model.status === MLModelStatus.PreTrained
    ) {
      goToLabelDataScreen(true)
      return
    }

    goToBaseModelScreen(true)
  }, [
    model,
    isFetchedAfterMount,
    goToBaseModelScreen,
    goToLabelDataScreen,
    goToModelTrainingScreen
  ])

  return null
}
